import {Store,Module,ActionContext} from 'vuex'
import ListModule from './list-module'
import ListState from './list-state'
import MoistureData from '../entities/moisturedata'
import Ajax from '../../lib/ajax'
import PageResult from '@/store/entities/page-result';
import ListMutations from './list-mutations'
interface MoistureDataState extends ListState<MoistureData>{
    editMoistureData:MoistureData
}
class UserMutations extends ListMutations<MoistureData>{

}
class MoistureDataModule extends ListModule<MoistureDataState,any,MoistureData>{
    state={
        totalCount:0,
        currentPage:1,
        pageSize:10,
        list: new Array<MoistureData>(),
        filterlist:new Array<MoistureData>(),
        loading:false,
        editMoistureData:new MoistureData()
    }
    actions={
        async getAll(context:ActionContext<MoistureDataState,any>,payload:any){
            //console.log(payload.data);
            context.state.loading=true;
            let reponse=await Ajax.get('/api/services/app/MoistureData/GetPaged',{params:payload.data});
            context.state.loading=false;
            let page=reponse.data.result as PageResult<MoistureData>;
            context.state.totalCount=page.totalCount;
            context.state.list=page.items;
            context.state.filterlist=page.items;
        },
        async getPaged(context:ActionContext<MoistureDataState,any>,payload:any){
          
            context.state.loading=true;
            //debugger
            let reponse=await Ajax.get('/api/services/app/MoistureData/GetPaged',{params:payload.data});
            
            context.state.loading=false;
            let page=reponse.data.result as PageResult<MoistureData>;
            context.state.totalCount=page.totalCount;
            context.state.list=page.items;
            context.state.filterlist=page.items;
        },
        async getfilter(context:ActionContext<MoistureDataState,any>,payload:any){
            //console.log(payload.data);
            context.state.loading=true;
            let reponse=await Ajax.get('/api/services/app/MoistureData/GetAll',{params:payload.data});
            context.state.loading=false;
            let page=reponse.data.result as PageResult<MoistureData>;
            context.state.totalCount=page.totalCount;
            context.state.filterlist=page.items;
        },
        async create(context:ActionContext<MoistureDataState,any>,payload:any){
            await Ajax.post('/api/services/app/MoistureData/Create',payload.data);
        },
        async uploadimg(context:ActionContext<MoistureDataState,any>,payload:any){
            //console.log(payload.data.UploadData);
            await Ajax.post('/api/services/app/UploadFile/UploadFile',{params:payload.data.UploadData});
        },
        async update(context:ActionContext<MoistureDataState,any>,payload:any){
            await Ajax.put('/api/services/app/MoistureData/Update',payload.data);
        },
        async delete(context:ActionContext<MoistureDataState,any>,payload:any){
            await Ajax.delete('/api/services/app/MoistureData/Delete?Id='+payload.data.id);
        },
        async get(context:ActionContext<MoistureDataState,any>,payload:any){
            let reponse=await Ajax.get('/api/services/app/MoistureData/GetById?Id='+payload.id);
            return reponse.data.result as MoistureData;
        },
        async getPageByDate(context: ActionContext<MoistureDataState, any>, payload: any) {
            let reponse = await Ajax.get('/api/services/app/MoistureData/GetPageByDate', { params: payload.data });
            let page = reponse.data.result as PageResult<MoistureData>;
            return page.items;
        },
        async getPagedLast(context: ActionContext<MoistureDataState, any>, payload: any) {
            // context.state.loading = true;
            let reponse = await Ajax.get('/api/services/app/MoistureData/GetPagedLast', { params: payload.data });
            // context.state.loading = false;
            let page = reponse.data.result as PageResult<MoistureData>;
            //context.state.totalCount = page.totalCount;
            //context.state.list = page.items;
            return page.items;
        },
    };
    mutations={
        setCurrentPage(state:MoistureDataState,page:number){
            state.currentPage=page;
        },
        setPageSize(state:MoistureDataState,pagesize:number){
            state.pageSize=pagesize;
        },
        edit(state:MoistureDataState,MoistureData:MoistureData){
            
            state.editMoistureData=MoistureData;
            //console.log(state.editFloor);
        }
    }
}
const moistureDataModule=new MoistureDataModule();
export default moistureDataModule;